var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20.5,
    viewBox: "0 0 18 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29028",
    "data-name": "Group 29028",
    transform: "translate(-8.959 -12.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share",
    d: "M13.687,13.028a3.163,3.163,0,0,0-2.344,1.038L6.124,10.833a3.158,3.158,0,0,0,0-2.3L11.343,5.3a3.17,3.17,0,1,0-.609-.982L5.514,7.552a3.17,3.17,0,1,0,0,4.264l5.219,3.233a3.17,3.17,0,1,0,2.954-2.021ZM11.673,3.17a2.014,2.014,0,1,1,2.014,2.014A2.016,2.016,0,0,1,11.673,3.17ZM3.17,11.7A2.014,2.014,0,1,1,5.184,9.684,2.017,2.017,0,0,1,3.17,11.7Zm8.5,4.5a2.014,2.014,0,1,1,2.014,2.014A2.016,2.016,0,0,1,11.673,16.2Zm0,0",
    transform: "translate(9.41 13.222)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1434",
    "data-name": "Ellipse 1434",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(18.959 12.515)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1438",
    "data-name": "Ellipse 1438",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(8.959 19.015)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1437",
    "data-name": "Ellipse 1437",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(18.959 25.015)",
    fill: "#f7d05c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a165a147f5e95a7f2b6c4f2fa5fa16ed.svg";
export { ForwardRef as ReactComponent };